import { Grid } from "@mui/material";
import MxTypography from "../../MxTypography";
import { ResponsiveStyleValue } from "@mui/system";

interface MxFormDescriptionTitleProps {
  label: string;
  color?: ResponsiveStyleValue<string | readonly string[] | undefined>;
}
const MxFormDescriptionTitle = (props: MxFormDescriptionTitleProps) => {
  return (
    <Grid item xs={12}>
      <MxTypography fontWeight={300} variant="overline" color={props.color || "grey.700"}>
        {props.label}
      </MxTypography>
    </Grid>
  );
};

export default MxFormDescriptionTitle;
